import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BusinessArea, Iv24Intention } from '../../@types/ownerBackendReceiveLeadRequest'

export interface Iv24TrackingData {
  businessArea?: BusinessArea
  iv24Intention?: Iv24Intention
  adGroup?: string
  adKeyword?: string
  adPlacement?: string
  adCampaign?: string
  adChannel?: string
  adDevice?: string
  formUrl?: string
  formPage?: string
  formType?: string
  qcTransactionId?: string
  kwMatchType?: string
  clickId?: string
}

const initialState: Iv24TrackingData = {}

const iv24TrackingSlice = createSlice({
  name: 'iv24TrackingData',
  initialState: initialState,
  reducers: {
    updateBusinessArea: (state, action: PayloadAction<BusinessArea>) => {
      state.businessArea = action.payload
    },
    updateIv24Intention: (state, action: PayloadAction<Iv24Intention>) => {
      state.iv24Intention = action.payload
    },
    updateAdGroup: (state, action: PayloadAction<string>) => {
      console.log(action)
      state.adGroup = action.payload
    },
    updateAdKeyword: (state, action: PayloadAction<string>) => {
      state.adKeyword = action.payload
    },
    updateAdPlacement: (state, action: PayloadAction<string>) => {
      state.adPlacement = action.payload
    },
    updateAdCampaign: (state, action: PayloadAction<string>) => {
      state.adCampaign = action.payload
    },
    updateAdChannel: (state, action: PayloadAction<string>) => {
      state.adChannel = action.payload
    },
    updateAdDevice: (state, action: PayloadAction<string>) => {
      state.adDevice = action.payload
    },
    updateFormUrl: (state, action: PayloadAction<string>) => {
      state.formUrl = action.payload
    },
    updateFormPage: (state, action: PayloadAction<string>) => {
      state.formPage = action.payload
    },
    updateFormType: (state, action: PayloadAction<string>) => {
      state.formType = action.payload
    },
    updateQcTransactionId: (state, action: PayloadAction<string>) => {
      state.qcTransactionId = action.payload
    },
    updateKwMatchType: (state, action: PayloadAction<string>) => {
      state.kwMatchType = action.payload
    },
    updateClickId: (state, action: PayloadAction<string>) => {
      state.clickId = action.payload
    },
  },
})

export const {
  updateBusinessArea,
  updateIv24Intention,
  updateAdGroup,
  updateAdKeyword,
  updateAdPlacement,
  updateAdCampaign,
  updateAdChannel,
  updateAdDevice,
  updateClickId,
  updateFormUrl,
  updateFormPage,
  updateFormType,
  updateQcTransactionId,
  updateKwMatchType,
} = iv24TrackingSlice.actions

export default iv24TrackingSlice.reducer
